/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { TestingResponseDto } from '../models/TestingResponseDto';

export class TestingService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get Testing Inventory
   * Fetch inventory via the real medical plans service (mocked in tests).
   *
   * Builds a synthetic profile inline (no monolith profile fetch) so
   * the endpoint focuses solely on exercising the inventory ext-api
   * path.
   * @returns TestingResponseDto Successful Response
   * @throws ApiError
   */
  public getTestingInventoryDiscoveryV1TestingInventoryGet(): CancelablePromise<TestingResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/discovery/v1/_testing/inventory',
    });
  }
}
